module.exports = __webpack_public_path__ + "static/media/Fort_Macon_History_Museum_Atlantic_Beach_NC_marsh_installed.9ead58a7.webp";